export default {
  group: {
    name: 'String',
  },
  user: {
    accountId: 'String',
  },
}
